<template>
  <v-row
    no-gutters
    id="avatar-wrapper"
    :style="{ height: height + 'px', width: width + 'px' }"
  >
    <v-col align="center" justify="center" id="divVHSS" cols="12"> </v-col>
    <div id="avatar-accessories">
      <div
        style="width: 600px; margin-left: 215px; margin-bottom: 10px"
        v-if="width > 600"
      >
        <v-row no-gutters>
          <v-col cols="1" @click="initiateLogout('1')">
            <v-btn height="100" class="d-none">Close</v-btn>
          </v-col>
          <v-col cols="10">
            <v-card
              style="border-radius: 30px !important"
              class="d-flex justify-center py-4"
              color="rgb(255, 255, 255, 0.7)"
            >
              <img width="450" src="@/assets/logo.png" />
            </v-card>
          </v-col>
          <v-col cols="1" @click="initiateLogout('2')">
            <v-btn height="100" class="d-none">Close</v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "avatar",
  props: {
    initialWidth: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      width: this.initialWidth,
      count: 0,
    };
  },
  computed: {
    ...mapGetters([
      "getCurrentLanguage",
      "getAvatarSpeech",
      "getIsSpeaking",
      "getDefaultBubbleText",
      "getenableADA",
      "getAvatarLangCodes",
      "getAvatarID",
      "getAvatarLoaded",
    ]),
    height: {
      get() {
        if (this.$route.path === "/" || this.$route.path === "/loadData") {
          // return this.width * 1.125 - 180
          return this.width - 150;
        }
        return this.width - 15;
      },
      set(newVal) {
        this.width = newVal;
      },
    },
    spVoice: function () {
      return this.getAvatarLangCodes.voiceId;
    },
    spLang: function () {
      return this.getAvatarLangCodes.langId;
    },
    spEngine: function () {
      return this.getAvatarLangCodes.engineId;
    },
  },
  watch: {
    '$route'(to, from) {
    this.$nextTick(() => {
      // Re-calculate the height based on your logic
      if (this.$route.path === "/" || this.$route.path === "/loadData") {
        this.width = this.initialWidth; // Or your specific logic
      }
      
      // Tell SitePal to redraw itself at the correct size
      if (this.getAvatarLoaded) {
        this.forceResize();
      }
    });
  },

  // This ensures that if the width changes for any reason, SitePal updates
  width: function () {
    this.forceResize();
  },
    getAvatarSpeech(newVal) {
      console.log("At avatar speech watch: ", newVal);
      this.speak(newVal);
    },
    getAvatarLoaded(newVal) {
      console.log("New Value at :", newVal);
      // if (!newVal) {
      //   console.log('Coming in here? Setting width to 0')
      //   this.width = 0
      // }
    },
    //   '$store.state.showDemoApp': function(isDemoVisible) {
    //   if (!isDemoVisible) {
    //     // When demo closes, wait for DOM then re-bind callbacks
    //     this.$nextTick(() => {
    //       this.bindSitepalCallbacks();
    //     });
    //   }
    // },
  },
  methods: {
    speak: function (speakText) {
      // Check if the SitePal function exists AND the scene is actually loaded
      if (typeof window.sayText !== "function" || !this.getAvatarLoaded) {
        console.warn("SitePal not ready. Retrying...");
        setTimeout(() => this.speak(speakText), 500);
        return;
      }

      if (this.getIsSpeaking) window.stopSpeech();

      window.sayText(speakText, this.spVoice, this.spLang, this.spEngine);
    },
    forceResize: function () {
      window.dynamicResize(this.width, this.height);
    },
    reInitialize: function () {
      this.width = this.initialWidth;
      this.forceResize();
      if (!this.getAvatarLoaded) {
        this.$store.commit("setAvatarLoaded", false);
      }
    },
    initiateLogout(value) {
      if (this.count === 0) {
        console.log("Set Timeout Called: ");
        setTimeout(() => {
          this.count = 0;
        }, 40000);
      }
      if (value === "1") {
        this.count = 1;
      } else {
        if (this.count >= 1) {
          console.log("Initiate Logout Count: ", this.count);
          this.count = this.count + 1;
          if (this.count === 7) {
            // call logout
            this.count = 0;
            this.$store.dispatch("logout");
          }
        }
      }
    },
  },

  // unmounted() {
  //   // This explicitly sets the loaded state to false when the component is
  //   // removed from the DOM (i.e., when the dialog is open).
  //   this.$store.commit("setAvatarLoaded", false);
  // },
  mounted() {
  this.$nextTick(() => {
    // RE-BIND global callbacks every time this component mounts.
    // This is critical because when you close the demo, 
    // these globals need to point to the NEW component instance.
    window.vh_sceneLoaded = () => {
      console.log("SitePal Scene Loaded Successfully");
      this.forceResize();
      this.$store.commit("setAvatarLoaded", true);
    };

    window.vh_audioStarted = () => {
      this.$store.commit("setIsSpeaking", true);
    };

    window.vh_talkEnded = () => {
      this.$store.commit("setIsSpeaking", false);
    };
  });
},
};
</script>

<style>
#divVHSS {
  width: 100%;
  z-index: 0 !important;
  animation: none !important;
  transform: translateY(0) !important;
}

#divVHSS-inner {
  left: -10px !important;
  bottom: 0px !important;
}

.character,
.vhss_main_container,
._html5Player {
  /* height: 1085px !important; */
  margin-top: -10px !important;
  z-index: -1 !important;
  position: initial !important;
}

#avatar-accessories {
  z-index: 1;
  height: 83%;
  /* width: 100%; */
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  position: absolute;
}
</style>
